export const FAX_PREVIEW = {
  FAX_ID: 'Fax ID',
  CLOSE: 'Close',
  PROGRAM: 'Program',
  RECEIVED_FROM: 'Received From',
  RECEIVED_ON: 'Received on',
  ORIGINATED_FROM_FAX_ID: 'Originated from Fax ID :',
  ORIGINATED_FROM_MAIL_ID: 'Originated from Mail ID :',
  AGENT_NAME: 'Agent Name',
  AGENT_EMAIL: 'Agent Email',
  MAIL_ID: 'Mail ID',
  AE_PC_STATUS: 'AE/PC Status',
}
export const EMAIL_PREVIEW = {
  INTAKE_ID: 'INTAKE ID',
  PATIENT_ENROLLMENT: 'Patient Enrollment',
  ATTACH_CASE: ' Attach Case',
  CREATE_NEW_CASE: 'Create New Case',
  ADVANCED_FILTERS: 'Advanced Filters',
  CLEAR: 'Clear',
  SEARCH: 'Search',
  BACK: '< Back',
  CASE: 'Case',
  SEARCH_RESULT: 'Search Result',
  SEARCH_AND_CREATE_CASE: 'Search & Create Case',
  RESULTS_FOUND: 'Results found',
  VIEW: 'view',
  ORIGINATED_FROM_EMAIL_ID: 'Originated from Email ID :',
}

export const WEB_PREVIEW = {
  ENROLLMENT_ID: 'Enrollment ID',
}

export const CHECK_ATTACH_IF_CASE = 'checkIfAttachCase'

export enum NavigationTypes {
  NEW_WINDOW = 'NEW_WINDOW',
  SAME_WINDOW = 'SAME_WINDOW',
}

export const INTAKE_CASE_VIEW__LISTING_COLUMNS = [
  'case_id',
  'program',
  'product',
  'channel',
  'case_type',
  'case_subtype',
  'assignee',
  'overall_case_status',
  'case_status',
  'outcome',
  'outcome_reason',
  'requestor_first_name',
  'requestor_last_name',
  'requestor_phone_number',
  'requestor_fax_number',
  'patient_first_name',
  'patient_last_name',
  'patient_dob',
  'patient_phone_number',
  'patient_fax_number',
  'provider_first_name',
  'provider_last_name',
  'provider_phone_number',
  'provider_fax_number',
  'provider_npi',
  'healthcare_facility_name',
  'healthcare_facility_address_line_1',
  'healthcare_facility_phone_number',
  'healthcare_facility_fax_number',
  'payer',
  'request_received_at',
  'case_start_date',
  'legacy_id',
  'created_at',
  'created_by',
  'modified_at',
  'modified_by',
  'enrollment_status__name',
  'enrollment_start_date',
  'enrollment_end_date',
]

export const FILTER_FIELDS = {
  case: [
    'c_case_statuses',
    'c_sub_services',
    'products',
    'services',
    'intake_channel',
  ],
  communication: ['category_status', 'programs'],
  hcp_portal_entity: ['hcp_program', 'enrollment_status', 'product'],
  patients_view: [
    'Patient Journey Status',
    'Patient Journey Status Reason',
    'City',
    'State',
  ],
  providers_view: ['Specialty'],
  contacts: ['contact_type'],
  contact_view: ['person_sub_type', 'city', 'state'],
  cases_entity_search_view: [
    'product',
    'case_type',
    'case_subtype',
    'case_status',
    'channel',
  ],
  payers: ['payer_type', 'name', 'payer_status'],
  plans: ['plan_type', 'name'],
  pharmacies: ['pharmacy_type'],
  pharmacy_view: ['pharmacy_type'],
  facilities_view: ['Facility Type'],
  organizations: ['organization_type'],
  organization_entity_search_view: ['organization_type'],
  patient_cases_view: [
    'product_name',
    'service_type',
    'sub_service_type',
    'case_status',
    'channel',
  ],
  provider_cases_view: [
    'product_name',
    'service_type',
    'sub_service_type',
    'case_status',
    'channel',
  ],
  contact_cases_view: [
    'product_name',
    'service_type',
    'sub_service_type',
    'case_status',
    'channel',
  ],
}

export const PERSON_RECORD_KEYS = {
  CONTACT_KEY: 'contact_key',
  PROVIDER_KEY: 'provider_key',
  PATIENT_KEY: 'patient_key',
  ORGANIZATION_KEY: 'organization_key',
  FACILITY_KEY: 'facility_key',
  PHARMACY_KEY: 'pharmacy_key',
  PAYER_KEY: 'payer_key',
}

export const NON_FILTER_FIELDS = {
  communication: ['category_status'],
  payers: ['payer_type'],
  plans: ['plan_type'],
  pharmacies: ['pharmacy_type'],
  pharmacy_view: ['pharmacy_type'],
}
